import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class OrderGroupService {

    constructor(
        private http: HttpClient
    ) { }

    // Get ALL Order groups
    public getAllOrderGroups() {
        return this.http.get(environment.apiUrl + 'api/ext-workplace')
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get All Order Groups by Store
    public getAllOrderGroupsByStore(id) {
        return this.http.get(environment.apiUrl + 'api/ext-workplace/by-store/' + id + '?size=9999')
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get Order group by Order group id
    public getOrderGroupById(id) {
        return this.http.get(environment.apiUrl + 'api/ext-workplace/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create Order Group
    public createOrderGroup(storeid, obj) {
        const body = {
            address: obj.address,
            contact: obj.contact,
            shortname: obj.shortname,
            name: obj.name,
            storeId: storeid,
            telephone: obj.telephone
        };
        return this.http.post(environment.apiUrl + 'api/ext-workplace', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Edit Order Group
    public editOrderGroup(groupid, obj) {
        const body = {
            address: obj.address,
            contact: obj.contact,
            id: groupid,
            identifier: obj.identifier,
            name: obj.name,
            telephone: obj.telephone
        };
        return this.http.put(environment.apiUrl + 'api/ext-workplace', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Delete Order Group
    public deleteOrderGroup(id) {
        return this.http.delete(environment.apiUrl + 'api/ext-workplace/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // *************** //
    // WORKPLACE SLOTS //
    // *************** //

    // Get All Workplace Slots
    public getAllWorkplaceSlots() {
        return this.http.get(environment.apiUrl + 'api/ext-workplace-slot')
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get All Workplace Slots by Workplace
    public getAllWorkplaceSlotsByWorkplace(id) {
        return this.http.get(environment.apiUrl + 'api/ext-workplace-slot/by-workplace/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create Workplace Slot
    public createWorkplaceSlot(workplaceid, obj) {
        const body = {
            cutoffTime: obj.cutOffTime,
            fulfillmentTime: obj.fulfillmentTime,
            name: obj.name,
            monday: obj.monday,
            tuesday: obj.tuesday,
            wednesday: obj.wednesday,
            thursday: obj.thursday,
            friday: obj.friday,
            saturday: obj.saturday,
            sunday: obj.sunday,
            workplaceId: workplaceid
        };
        return this.http.post(environment.apiUrl + 'api/ext-workplace-slot', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Edit Workplace Slot
    public editWorkplaceSlot(workplaceslotid, obj) {
        const body = {
            cutoffTime: obj.cutOffTime,
            fulfillmentTime: obj.fulfillmentTime,
            name: obj.name,
            monday: obj.monday,
            tuesday: obj.tuesday,
            wednesday: obj.wednesday,
            thursday: obj.thursday,
            friday: obj.friday,
            saturday: obj.saturday,
            sunday: obj.sunday,
            id: workplaceslotid
        };
        return this.http.put(environment.apiUrl + 'api/ext-workplace-slot', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Delete Workplace Slot
    public deleteWorkplaceSlot(id) {
        return this.http.delete(environment.apiUrl + 'api/ext-workplace-slot/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }


    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }


    public handleDataWithHeaders(res: HttpResponse<any>) {

        const headers = res.headers;
        const body = res.body;
        const data = {
            'headers': headers,
            'body': body
        };
        return data;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/order-group.service.ts